// extracted by mini-css-extract-plugin
export var growableInput = "_74-0";
export var tagContainer = "_74-2";
export var textInput = "_74-1";